import { QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { ConfirmProvider } from "@/components/ui/confirm-dialog";
import { StepUpProvider } from "@/components/ui/step-up-dialog";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { createQueryClient } from "@/lib/query";
import { ThemeProvider } from "@/lib/theme";
import { AuthProvider } from "./auth/session";
import { AppRouter } from "./router";

/**
 * Provider stack, outermost first:
 *   QueryClient → Theme → Auth (needs the cache) → Tooltip → Confirm → Router.
 * Providers that need router hooks (realtime) live in the router's root layout.
 */
export function App() {
  const [queryClient] = useState(createQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <TooltipProvider delayDuration={250} skipDelayDuration={400}>
            <ConfirmProvider>
              <StepUpProvider>
                <AppRouter />
              </StepUpProvider>
            </ConfirmProvider>
            <Toaster />
          </TooltipProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
